/*
 * An app-icon tile, after Adobe's: a rounded tile in a deep shade of the analysis's
 * tint, with the code in the tint itself. The code is set in Source Sans 3, Adobe's
 * open-source sans and the nearest free face to the Adobe Clean on its icons. Like
 * Adobe's, the tile stays dark on a light section too. The parent sizes it with
 * --chip-size (2.25rem by default, which draws a 2.7rem x 2rem tile); its box, type
 * and corners scale from that. tests/unit/codeChip.test.js holds every code to 4.5:1
 * on its tile.
 */
.chip {
  --size: var(--chip-size, 2.25rem);
  display: inline-grid;
  place-items: center;
  min-width: calc(var(--size) * 1.2);
  height: calc(var(--size) * 8 / 9);
  padding-inline: calc(var(--size) * 0.06);
  border-radius: calc(var(--size) * 0.2);
  background: color-mix(in srgb, var(--tint) 18%, #000);
  color: var(--tint);
  font-family: "Source Sans 3 Variable", var(--font-text);
  font-size: calc(var(--size) * 0.49);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.01em;
}
/* Where the browser can: the tint's own hue at a fixed dark lightness, which keeps more of
   its colour than mixing toward black does, as Adobe's deep backgrounds do. */
@supports (color: oklch(from red 0.22 calc(c * 0.6) h)) {
  .chip {
    background: oklch(from var(--tint) 0.22 calc(c * 0.6) h);
  }
}
/* A four-character code (CS3D) sets smaller, so every tile keeps the same width. */
.chip[data-long] {
  font-size: calc(var(--size) * 0.44);
}
